<template>
  <div class="sms-cell">
    <div class="sms-cell-top">
      <span class="cell-level" :class="getRiskLevelBgColor(cardData)"></span>
      <span class="cell-title">{{ system.name }}</span>
    </div>
    <div class="sms-cell-bottom">
      <div class="achievement-index-left">
        <div class="index-name">子流程 :</div>
        <div class="index-name">检查 :</div>
        <div class="index-name">KPI :</div>
      </div>
      <div class="achievement-index-right">
        <div class="index-value">
          <span class="risk-level-color-red">{{ cardData.subProcess.red }}</span>
          /
          <span class="risk-level-color-orange">{{ cardData.subProcess.orange }}</span>
          /
          <span class="risk-level-color-yellow">{{ cardData.subProcess.yellow }}</span>
          /
          <span class="risk-level-color-green">{{ cardData.subProcess.green }}</span>
        </div>
        <div class="index-value">
          <span class="risk-level-color-red">{{ cardData.check.red }}</span>
          /
          <span class="risk-level-color-orange">{{ cardData.check.orange }}</span>
          /
          <span class="risk-level-color-yellow">{{ cardData.check.yellow }}</span>
          /
          <span class="risk-level-color-green">{{ cardData.check.green }}</span>
        </div>
        <div class="index-value">
          <span class="risk-level-color-red">{{ cardData.kpi.red }}</span>
          /
          <span class="risk-level-color-yellow">{{ cardData.kpi.yellow }}</span>
          /
          <span class="risk-level-color-blue">{{ cardData.kpi.blue }}</span>
          /
          <span class="risk-level-color-green">{{ cardData.kpi.green }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getRequest} from "../../../utils/request";

export default {
  props: {
    //系统
    system: Object,
  },
  data() {
    return {
      cardData: {
        subProcess: {
          red: "..",
          orange: "..",
          yellow: "..",
          blue: "..",
          green: "..",
        },
        check: {
          red: "..",
          orange: "..",
          yellow: "..",
          blue: "..",
          green: "..",
        },
        kpi: {
          red: "..",
          yellow: "..",
          blue: "..",
          green: "..",
        }
      }
    }
  },
  mounted() {
    getRequest("process/key/card", {
      system: this.system.code
    }).then(res => {
      this.cardData = res.data;
    })
  },
  methods: {
    getRiskLevelBgColor(data) {
      return this.$util.getRiskLevelBgColor(data ? data.levelColor : null);
    },
  }
}
</script>

<style scoped lang="less">
.sms-cell-top {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.cell-level {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.cell-title {
  margin: 0 8px;
  font-weight: bold;
  font-size: 14px;
}

.sms-cell-bottom {
  display: flex;
  align-items: center;
  font-size: 12px;
}

.achievement-index-right {
  margin-left: 4px;
}

.index-name, .index-value {
  line-height: 20px;
}

.index-value span {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/achievement/process/KeyProcessCard.vue